import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UnitHasWorkModel extends BaseModel {

    constructor() {
        super({
                name: "unit_has_work",
                tableName: 'unit_has_work',
                label: "Unit có công việc",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                unit_id: { 
                    name: 'unit_id',
                    display: false
                },
                work_id: { 
                    name: 'work_id',
                    display: false
                }

            },
            )
    }

}